import { Component } from '@angular/core';
import { FAQS } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-faq',
  templateUrl: './landing-faq.component.html',
  styleUrls: ['./landing-faq.component.scss'],
})
export class LandingFaqComponent {
  readonly faqs = FAQS;
  openIndex: number | null = null;

  toggle(index: number): void {
    this.openIndex = this.openIndex === index ? null : index;
  }
}
